import { c as _c } from "react/compiler-runtime";
import FileBody from "forms/fields/File/FileBody";
import type { FormControlType } from "types/formType";
import type { IProperty } from "types/jsonSchema";
import type { IFormInputs } from "types/uiSchema";
import { Fieldset } from "ui/Fieldset";
import { FormField } from "uiShadcn/form";
interface FileProps {
  control: FormControlType;
  uiData: IFormInputs;
  jsonData: Record<string, IProperty>;
}
export default function AddFile(t0) {
  const $ = _c(15);
  const {
    control,
    uiData,
    jsonData
  } = t0;
  const name = uiData["x-json-schema-reference-property"];
  let t1;
  if ($[0] !== uiData.required) {
    t1 = uiData?.required?.includes("true");
    $[0] = uiData.required;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isRequired = t1;
  let t2;
  if ($[2] !== jsonData || $[3] !== name) {
    t2 = jsonData[name]?.properties ?? {};
    $[2] = jsonData;
    $[3] = name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const jsonDataProperties = t2;
  if (!name) {
    return null;
  }
  const t3 = uiData?.description;
  let t4;
  if ($[5] !== isRequired || $[6] !== jsonDataProperties?.id) {
    t4 = t5 => {
      const {
        field
      } = t5;
      return <FileBody {...field} validators={jsonDataProperties?.id["x-validators"] ?? []} isRequired={isRequired} />;
    };
    $[5] = isRequired;
    $[6] = jsonDataProperties?.id;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== control || $[9] !== name || $[10] !== t4) {
    t5 = <FormField control={control} name={name} render={t4} />;
    $[8] = control;
    $[9] = name;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <Fieldset title={t3}>{t5}</Fieldset>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}